export function formatOrgList(names: string[]): string {
  const unique = [...new Set(names.map((name) => name.trim()).filter((name) => name !== ''))]
  if (unique.length <= 1) return unique[0] ?? ''
  if (unique.length === 2) return `${unique[0]} and ${unique[1]}`
  return `${unique.slice(0, -1).join(', ')}, and ${unique[unique.length - 1]}`
}
